const firebaseConfig = {
    apiKey: "AIzaSyAbER04PNvOiIFE9c5kBW9xsLMkLIwHPj8",
    authDomain: "heal-lab.firebaseapp.com",
    projectId: "heal-lab",
    storageBucket: "heal-lab.appspot.com",
    messagingSenderId: "423362394493",
    appId: "1:423362394493:web:ec83946f759dcc09abb414"
  };

export default firebaseConfig;